import React from 'react';

interface Props {
    showLastUnitsMsg?: boolean;
    showStock?: boolean;
    lastUnitsMsg?: string;
    availableUnits: number;
    requiredQuantity: number;
    insufficientUnitsMsg: string;
}

export const ProductAvailabilityUI = (props: Props) => {
    const {
        showLastUnitsMsg,
        showStock,
        lastUnitsMsg,
        availableUnits,
        requiredQuantity,
        insufficientUnitsMsg
    } = props;

    const blackTextStyle = { color: "#000 !important" }; // Forzar negro

    return (
        <>
            {
                (() => {
                    let result;
                    if (showLastUnitsMsg === true) {
                        result = (
                            <small className="text-info">
                                {lastUnitsMsg || 'Últimas unidades disponibles'}
                            </small>
                        );
                    } else if (availableUnits <= 0) {
                        if (!!insufficientUnitsMsg) {
                            result = (
                                <small style={blackTextStyle}>{insufficientUnitsMsg}</small>
                            );
                        } else {
                            result = (
                                <small style={blackTextStyle}>Disponible próximamente</small>
                            );
                        }
                    } else if (showStock === false && (!requiredQuantity || (requiredQuantity <= availableUnits))) {
                        result = (
                            <small className="text-primary">Producto disponible</small>
                        );
                    } else if (showStock === false || (requiredQuantity > availableUnits)) {
                        if (!!insufficientUnitsMsg) {
                            result = (
                                <small style={blackTextStyle}>{insufficientUnitsMsg}</small>
                            );
                        } else {
                            result = (
                                <small style={blackTextStyle}>Stock insuficiente.</small>
                            );
                        }
                    } else {
                        result = (
                            <small className="text-primary">{availableUnits} unidades disponibles</small>
                        );
                    }
                    return result;
                })()
            }
        </>
    );
};
